import { StoreModel } from '../../models/Index';
import { logger, LogEvents } from 'helpers/Logger';

export default function returnCash(Store: StoreModel, event: any) {
    logger.localLog(
        'Return Cash due to update transaction fail',
        LogEvents.ReturnCash
    );

    return Store.shellClient.cashAcceptor.processReturnCash();
}
